import { Attachment } from "@rms-types/modules/attachment/entities/attachment";

const index = "attachment";

const getOneAttachment = (id: Attachment["id"]) => `${index}/${id}`;

const getDownloadUrl = (id: Attachment["id"]) => `${getOneAttachment(id)}/get-download-url`;

export const attachmentEndpoint = Object.freeze({
  attachment: index,
  attachmentBulk: `${index}/bulk`,

  getOneAttachment,
  getDownloadUrl,
});
